import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetAg2Applications = ApiClient['v1']['ag2-applications']['$get'];
export type Ag2ApplicationListResponse = InferResponseType<GetAg2Applications, 200>;
export type Ag2Application = Ag2ApplicationListResponse['applications'][number];

export function useWorkspaceAg2Applications(ag2ProductId: string | null | undefined) {
  return useFetch<Ag2ApplicationListResponse>(
    ag2ProductId ? ['ag2-applications', ag2ProductId] : null,
    (client) =>
      client.v1['ag2-applications'].$get({
        query: { ag2ProductIdIn: ag2ProductId ? [ag2ProductId] : [] },
      })
  );
}
